import { Grid, Paper, Typography } from "@mui/material";
import React from "react";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import { HeaderList } from "../../Components/Header/HeaderList";
import { useForm } from "react-hook-form";
import WSPhone from "../../Components/Phone/WSPhone";
import {
  customValidation,
  validations,
} from "../../commonFunctions/CommonFunctions";
import WSSelectField from "../../Components/Select/WSSelect";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSButton from "../../Components/Button/WSButton";
import config from "../../Config/clientConfig.json"
export const GstReturns: React.FC<any> = React.memo((props) => {
  const { register, control } = useForm();
  return (
    <>
      <HeaderList
        title={"GST Returns Filing by Experts"}
        type="card"
        position="relative"
        isBackButton={true}
        url="/products"
      />
      <Paper
        elevation={3}
        style={{
          paddingLeft: 20,
          paddingRight: 20,
          marginTop: 0,
          paddingBottom: 25,
          border: "1px solid #ccc",
          borderRadius: "8px",
        }}
      >
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12} p={2}>
            <Typography>Please Fill The Form Below</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <WSTextField
              label={"Enter  Name *"}
              {...register("fullName")}
              id="fullName"
              name="fullName"
              control={control}
              rules={{ required: false }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <WSPhone
              label={"Enter Phone Number *"}
              id={"phoneNumber"}
              name={"phoneNumber"}
              control={control}
              rules={{ required: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <WSTextField
              className="form-control"
              id="email"
              type={TextType.Text}
              rules={customValidation(false, validations.email)}
              {...register("email")}
              label="Enter Email * "
              control={control}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <WSTextField
              label={"Enter Pincode *"}
              {...register("pinCode")}
              id="pinCode"
              name="pinCode"
              control={control}
              rules={{ required: false }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <WSTextField
              label={"Enter GST Number *"}
              {...register("gstNumber")}
              id="gstNumber"
              name="gstNumber"
              control={control}
              rules={{ required: false }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <WSSelectField
              rules={{ required: true }}
              control={control}
              id="service"
              {...register("service")}
              name="service"
              label="Select Service *"
              options={config.serviceConfig.staticOptionData}
            />
          </Grid>

          <Grid item xs={12} textAlign={"center"}>
            <WSButton
              id="submit"
              type="submit"
              label="Apply Now"
              size="medium"
              variant="outlined"
              color="primary"
              sx={{
                borderRadius: 2,
                border: "1px solid rgba(126, 176, 246, 1)",
                color: "#FFFFFF",
                backgroundColor: "rgba(126, 176, 246, 1)",
                "&:hover": {
                  backgroundColor: "rgba(126, 176, 246, 1)",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Grid display="flex" flexDirection="column" alignItems="center">
              <WSIcons.AccessAlarmIcon fontSize="large" />
              <Typography variant="caption" mt={1}>
                Due Date Reminder
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Grid display="flex" flexDirection="column" alignItems="center">
              <WSIcons.DescriptionIcon fontSize="large" />
              <Typography variant="caption" mt={1}>
                Completely Digital Processing
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Grid display="flex" flexDirection="column" alignItems="center">
              <WSIcons.ElectricBoltIcon fontSize="large" />
              <Typography variant="caption" mt={1}>
                Prompt Response
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
});
